module.exports = __webpack_public_path__ + "static/media/fa-brands-400.c5e0f14f.woff";